import React from 'react';
import { motion } from 'framer-motion';
import { Star } from 'lucide-react';
const testimonials = [{
  initials: 'SM',
  name: 'S.M.',
  role: 'Food Science Teacher | Chicago, IL',
  text: '“I used to spend every Sunday night building lessons from scratch — searching for activities, writing objectives, finding case studies. Now I open the library, choose the lesson, and walk into class completely prepared. My students notice the difference. And so do I.”'
}, {
  initials: 'CV',
  name: 'C.V.',
  role: 'Food Safety Instructor | Houston, TX',
  text: '“The case study bank alone saved me during the first three weeks of school. I had real industry situations ready to use before I even finished setting up my classroom.”'
}, {
  initials: 'JR',
  name: 'J.R.',
  role: 'Foods and Nutrition Teacher | Phoenix, AZ',
  text: '“The visual glossary changed how my students engage with vocabulary. Terms they used to struggle with suddenly clicked — because they could see them, not just read a definition.”'
}];
export function TestimonialsStrip() {
  return <section className="py-12 bg-dark-card border-y border-dark-border" data-id="element-237" data-mp="gdj5mjyk6e5n">
      <div className="max-w-7xl mx-auto px-4" data-id="element-238" data-mp="lddwwom8x5r8">
        <div className="text-center mb-7" data-id="element-239" data-mp="lcm0jbktr3zw">
          <p className="text-gold font-bold tracking-widest uppercase text-sm" data-id="element-240" data-mp="q440pxf0x0jt">
            ⭐ What Teachers Are Saying
          </p>
        </div>
        <div className="grid md:grid-cols-3 gap-6" data-id="element-241" data-mp="v25lqnw0f9xx">
          {testimonials.map((testimonial, index) => <motion.article key={testimonial.initials} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: index * 0.2
        }} className="bg-black border border-gold/20 p-6 rounded-2xl relative" data-id="element-242" data-mp="100yw47g02ktv" data-mpi={index}>
              <div className="flex gap-1 text-gold mb-4" aria-label="5 out of 5 stars" data-id="element-243" data-mp="3auctzh664sls">
                {[...Array(5)].map((_, starIndex) => <Star key={starIndex} size={16} fill="currentColor" data-id="element-244" data-mp="i0ntz8crlh7g" data-mpi={starIndex} />)}
              </div>
              <p className="text-gray-300 italic mb-6 text-sm leading-relaxed" data-id="element-245" data-mp="d2ck4xmgz6p8">
                {testimonial.text}
              </p>
              <div className="flex items-center gap-3" data-id="element-246" data-mp="m1g381lmzm3q">
                <div className="w-10 h-10 rounded-full bg-gold/10 border border-gold flex items-center justify-center text-gold font-bold" data-id="element-247" data-mp="m0ofte270uoj">
                  {testimonial.initials}
                </div>
                <div data-id="element-248" data-mp="vz4afr0fim2s">
                  <div className="font-bold text-white text-sm" data-id="element-249" data-mp="vxjfi0a7d14e">{testimonial.name}</div>
                  <div className="text-xs text-gold-light" data-id="element-250" data-mp="19q91w5tn8821">{testimonial.role}</div>
                </div>
              </div>
            </motion.article>)}
        </div>
      </div>
    </section>;
}